export const setSessionStorageItem = <T>(key: string, value: T) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const getSessionStorageItem = <T>(key: string): T | null => {
  const storedValue = sessionStorage.getItem(key);
  if (storedValue) {
    return JSON.parse(storedValue) as T;
  }
  return null;
};

export const clearSessionStorageFlag = (key: string) => {
  sessionStorage.removeItem(key);
};
